(function () {
  var SELECTOR = '[data-sticky-product-actions]';

  function getForm() {
    var productForm = document.querySelector('product-form');
    return productForm ? productForm.querySelector('form[data-type="add-to-cart-form"]') : null;
  }

  function isDisabled(button) {
    return !button || button.getAttribute('aria-disabled') === 'true' || button.disabled;
  }

  // The real "Buy now" slot renders one of three things (see
  // buy-buttons.liquid): Shopify's dynamic checkout button, our own
  // buy-via-cart button, or a locked "Unlocks at" gate. Look it up at
  // click time because Shopify injects its button asynchronously.
  function getRealBuyNow(form) {
    return (
      form.querySelector('[data-buy-now-via-cart]') ||
      form.querySelector('.shopify-payment-button__button:not(.shopify-payment-button__button--hidden)')
    );
  }

  function init(root) {
    if (!root || root.dataset.klStickyReady === 'true') return;
    root.dataset.klStickyReady = 'true';

    var form = getForm();
    if (!form) {
      root.remove();
      return;
    }

    var realSubmit = form.querySelector('[type="submit"]');
    var realButtons = form.querySelector('.product-form__buttons') || realSubmit;
    var addToCartBtn = root.querySelector('[data-sticky-add-to-cart]');
    var buyNowBtn = root.querySelector('[data-sticky-buy-now]');
    var buyNoteEl = root.querySelector('.sticky-product-actions__note--offer');
    var gate = form.querySelector('[data-buy-now-gate]');
    var hasBuySlot = !!form.querySelector('.buy-col--buy');

    if (!hasBuySlot && buyNowBtn) {
      // Dynamic checkout turned off for this product: single full-width button.
      buyNowBtn.parentNode.remove();
      buyNowBtn = null;
      root.classList.add('is-single');
    }

    function syncDisabledState() {
      var disabled = isDisabled(realSubmit);
      if (addToCartBtn) {
        addToCartBtn.disabled = disabled;
      }
      if (buyNowBtn) {
        var locked = !!gate;
        buyNowBtn.disabled = disabled || locked;
        // Locked below the order minimum: keep the button label short and
        // move the "Unlocks at ..." message into the small note under it.
        if (buyNoteEl && locked) {
          buyNoteEl.textContent = gate.textContent.replace(/\s+/g, ' ').trim();
          buyNoteEl.classList.add('is-locked');
        }
      }
    }

    syncDisabledState();

    if (realSubmit && window.MutationObserver) {
      new MutationObserver(syncDisabledState).observe(realSubmit, {
        attributes: true,
        attributeFilter: ['aria-disabled', 'disabled'],
      });
    }

    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function () {
        if (isDisabled(realSubmit)) return;
        realSubmit.click();
      });
    }

    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function () {
        if (buyNowBtn.disabled) return;
        var realBuy = getRealBuyNow(form);
        if (realBuy) realBuy.click();
      });
    }

    if (realButtons && window.IntersectionObserver) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            root.classList.toggle('is-visible', !entry.isIntersecting);
          });
        },
        { rootMargin: '0px 0px -10% 0px' }
      );
      observer.observe(realButtons);
    } else {
      root.classList.add('is-visible');
    }
  }

  function boot() {
    document.querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector ? event.target.querySelector(SELECTOR) : null;
    if (root) init(root);
  });
})();
